// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1959":"bb316c81c50a5d4c","3187":"ab79cfd529552e53"}[chunkId] + ".css";
};